import { render } from "./DiscountBadge.vue?vue&type=template&id=6a47a5fc"
import script from "./DiscountBadge.vue?vue&type=script&lang=js"
export * from "./DiscountBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__